import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import {
  apiRequest,
  setAccessToken,
  hasAccessToken,
} from "../services/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function initializeAuth() {
      try {
        if (!hasAccessToken()) {
          if (active) {
            setUser(null);
          }

          return;
        }

        const result = await apiRequest(
          "/auth/me",
          {},
          false
        );

        if (active) {
          setUser(result.data.user);
        }
      } catch {
        setAccessToken(null);

        if (active) {
          setUser(null);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    initializeAuth();

    return () => {
      active = false;
    };
  }, []);

  async function login(email, password) {
    const result = await apiRequest(
      "/auth/login",
      {
        method: "POST",
        body: JSON.stringify({
          email,
          password,
        }),
      },
      false
    );

    setAccessToken(result.accessToken);
    setUser(result.data.user);

    return result.data.user;
  }

  async function logout() {
    try {
      await apiRequest(
        "/auth/logout",
        {
          method: "POST",
        },
        false
      );
    } finally {
      setAccessToken(null);
      setUser(null);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);